export default {
    "default": {
        year: 2024,
        title: "GADDAR BİLGİ",
        text: "Bugün tarihte ne oldu bilmiyoruz ama Gaddar Bilgi'de her gün yeni bir macera seni bekliyor!",
        questions: [
            {
                text: "Gaddar Bilgi oyununda en yüksek puanı almak için hangi strateji daha önemlidir?",
                options: ["Hızlı Cevap Vermek", "Sadece İzlemek", "Rastgele Basmak", "Oyunu Kapatmak"],
                correct: 0
            }
        ]
    }
};
